import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          {/* <img src={j} alt="Avatar" /> */}
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="/" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Kerr Design</h1>
          <p>elegant | sophisticated | refined</p>
          <h4>custom high-end interior, exterior, holiday, and gift design</h4>

          <div className="mobile_social_icons">
            <a href="/" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;